<template>
  <v-checkbox
    v-if="showSelect && isSelect(header)"
    v-model="selectRows[rowIndex].value"
    @change="selected(rowIndex)"
  />

  <v-row
    v-else-if="!actionOptions.length
      && showActions && isActionsHeader(header) "
  >
    <v-col
      class="noWrap"
      cols="12"
    >
      <v-btn
        v-if="!hideEdit"
        class="dataTableEditButton"
        color="primary"
        icon
        @click="onClickEdit(row)"
      >
        <v-icon size="25">
          mdi-eye
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!hideDelete"
        class="dataTableDeleteButton"
        color="primary"
        icon
        @click="onClickDelete(row)"
      >
        <v-icon size="25">
          mdi-delete
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
  <v-menu
    v-else-if="actionOptions.length
      && showActions && isActionsHeader(header)"
    offset-y
    class="actionMenu"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        class="actionMenuButton"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-if="!hideEdit"
        class="dataTableEditButton"
        @click="onClickEdit(row)"
      >
        <v-list-item-avatar size="20">
          <v-icon size="20">
            mdi-eye
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="text2 secondary300">
          Visualizar detalhes
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="(item, index) in actionOptions"
        :key="index"
        class="dataTableActionOptions"
        @click="item.handler(row)"
      >
        <v-list-item-avatar
          v-if="item.icon"
          size="20"
        >
          <v-icon size="20">
            {{ getActionOptionIcon(item, row) }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="text2 secondary300">
          {{ getActionOptionName(item, row) }}
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="!hideDelete"
        class="dataTableDeleteButton"
        @click="onClickDelete(row)"
      >
        <v-list-item-avatar size="20">
          <v-icon size="20">
            mdi-delete
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="text2 secondary300">
          Excluir dados
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
  <component
    :is="header.component || 'DataTableTextColumn'"
    v-else-if="!isActionsHeader(header)
      && !isSelect(header) && !header.expanded"
    :key="generateKey(rowIndex, row.id)"
    :options="header.options"
    :height="header.height"
    :row="row"
    :data="data"
    :row-index="rowIndex"
    :index="headerIndex"
    :value="getColumnValue(row, header)"
    :header="header"
    :show-all-content="allColumnWidth"
    @update-page-by-column="updatedPage($event)"
  />
  <div
    v-else-if="(header.value === 'data-table-expand') || header.expanded"
    class="data-table-expand"
    @click="handleExpand(!expand)"
  >
    <v-icon v-if="!expand">
      mdi-chevron-down
    </v-icon>
    <v-icon v-else>
      mdi-chevron-up
    </v-icon>
  </div>
</template>

<script>
import DataTableCpfCnpjColumn from 'Arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumn from 'Arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import DataTableHeaderCell from 'Arch/components/data-table/DataTableHeaderCell.vue';
import DataTableTextColumn from 'Arch/components/data-table/DataTableColumns/DataTableTextColumn.vue';
import DataTableTransformValueColumn from 'Arch/components/data-table/DataTableColumns/DataTableTransformValueColumn.vue';
import DataTableCurrencyColumn from 'Arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableImgRow from 'Arch/components/data-table/DataTableColumns/DataTableImgRow.vue';
import DataTableStatusColumn from 'Arch/components/data-table/DataTableColumns/DataTableStatusColumn.vue';

export default {
  name: 'DataTableBodyComponents',
  components: {
    DataTableCpfCnpjColumn,
    DataTableDateColumn,
    DataTableHeaderCell,
    DataTableTextColumn,
    DataTableTransformValueColumn,
    DataTableCurrencyColumn,
    DataTableImgRow,
    DataTableStatusColumn,
  },
  props: {
    showSelect: {
      type: Boolean,
    },
    isSelect: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    selectRows: {
      type: Array,
      default() {
        return [];
      },
    },
    selected: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    actionOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    showActions: {
      type: Boolean,
    },
    header: {
      type: Object,
      default() {
        return {
          value: '',
          action: '',
          select: '',
        };
      },
    },
    hideEdit: {
      type: Boolean,
    },
    onClickEdit: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    hideDelete: {
      type: Boolean,
    },
    onClickDelete: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    row: {
      type: Object,
      default() {
        return {
          id: '',
        };
      },
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    getActionOptionIcon: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    getActionOptionName: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    generateKey: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    handleExpand: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    expand: {
      type: Boolean,
    },
    getPropByString: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    allColumnWidth: {
      type: Boolean,
    },
    updatedPage: {
      type: Function,
      default() {
        return (v) => v;
      },
    },
    headerIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isActionsHeader() {
      return (header) => header && (
        header.actions || header.value === 'data_table_actions'
      );
    },
    getColumnValue() {
      return (row, header) => this.handleColumnValue(
        header,
        this.getPropByString(row, header.value, header.default),
      );
    },
    handleColumnValue() {
      return (header, value) => (header && header.handler ? header.handler(value) : value);
    },
  },
};
</script>
